import React from 'react';
import { useSessionContext } from './SessionContext';

/* Two things the map used to be silent about.
 *
 * 1. FIXTURE DATA. `iceberg.divirod_water_level_index.admin_day` does not exist yet, so
 *    the administrative view can be pointed at a stand-in whose area ids, names and
 *    gauge counts are real but whose WLI values are synthetic. A synthetic index that
 *    renders exactly like a real one is the kind of thing that gets screenshotted into a
 *    deck, so the file carries `meta.fixture` and this says so on the map itself.
 *    When `export_map --source admin` writes the real file the flag is absent and the
 *    badge disappears with no code change.
 *
 * 2. A FAILED LOAD. Previously a rejected fetch left the scrubber on "Fetching data..."
 *    for ever with the reason only in the console. Switching views can fail now, so the
 *    reason has to be on screen.
 */
export default function StatusBanner() {
  const { meta, loadError, isLoading } = useSessionContext();

  if (loadError) {
    return (
      <div className="status-banner status-banner-error">
        <b>Could not load map data</b>
        <span>{loadError}</span>
      </div>
    );
  }

  if (isLoading) return null;

  if (meta && meta.fixture) {
    return (
      <div className="status-banner status-banner-fixture">
        <b>SAMPLE DATA</b>
        <span>
          Regions, names and gauge counts are real. Index values are synthetic
          placeholders, not a published Water Level Index.
        </span>
      </div>
    );
  }

  return null;
}
